var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
        'money-input': true,
        'el-input': true,
        'is-disabled': _vm.disabled,
        'el-input--small': _vm.size == 'small',
        'align-right': _vm.align === 'right',
        'align-center': _vm.align === 'center',
        'el-input-group': _vm.prepend !== null,
        'el-input-group--prepend': _vm.prepend !== null,
        'has-suffix': _vm.suffix !== null
    }},[(_vm.prepend)?_c('span',{staticClass:"el-input-group__prepend"},[_vm._v(_vm._s(_vm.prepend))]):_vm._e(),_c('input',{key:"input",ref:"input",staticClass:"el-input__inner disabled",attrs:{"disabled":_vm.disabled,"placeholder":_vm.placeholder},domProps:{"value":_vm.formatValue},on:{"input":function($event){return _vm.updateValue($event.target.value)},"blur":_vm.onBlur,"focus":_vm.selectAll,"change":_vm.onChange,"keyup":_vm.onKeyup,"click":_vm.onClick}}),(_vm.suffix)?_c('span',{staticClass:"suffix"},[_vm._v(_vm._s(_vm.suffix))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }